<template>
    <v-form class="my-2"
      v-model="detailMixin.valid"
      ref="formAlgemeen">
      <!-- Offline dialog -->
      <v-dialog
        v-model="showOfflineDialog"
        max-width="500"
        persistent
      >
        <v-card>
          <v-card-title class="headline">
            <v-icon left>mdi-wifi-off</v-icon>
            Geen internetverbinding
          </v-card-title>
          <v-card-text>
            Er is geen internetverbinding beschikbaar. Wilt u doorgaan met de laatst opgeslagen lokale gegevens?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="handleOfflineCancel"
            >
              Annuleren
            </v-btn>
            <v-btn
              color="primary"
              text
              @click="handleOfflineContinue"
            >
              Doorgaan met lokale data
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <div
      v-if="detailMixin.element && detailMixin.element.schatting && detailMixin.element.algemeneGegevens"
      :class="DetailMixin_Dirty ? 'dirtyForm' : DetailMixin_Revertable && !detailMixin.element.isNew ? 'editForm' : ''"
      >
        <h2 class="primary--text">Nieuwe schatting</h2>
        <h3 class="secondary--text my-3">Omschrijving opdracht</h3>
        <v-row
          class="pb-0"
        >
          <v-col cols="12" lg="6">
            <option-list
              v-model="detailMixin.element.schatting.opdracht"
              :list="opdrachtTemplates"
              label="Opdracht"
              :rules="[validationMixin.rules.required]"
            />
          </v-col>
        </v-row>
        <h3 class="secondary--text my-3">Verslag opgesteld door</h3>
        <v-row class="pb-0">
          <v-col cols="12" sm="6" lg="3">
            <v-text-field label="Naam"
              :value="detailMixin.element.schatting.gebruikerNaamOmgekeerd"
              readonly />
          </v-col>
          <v-col cols="12" sm="6" lg="3">
            <v-text-field label="Email"
              :value="detailMixin.element.schatting.gebruikerEmail"
              readonly />
          </v-col>
          <v-col cols="12" sm="6" lg="3">
            <control-select
              :items="gebruikers"
              label="Projectverantwoordelijke"
              v-model="detailMixin.element.schatting.idProjectverantwoordelijke"
              itemValue="idGebruiker"
              itemText="naam" />
          </v-col>
        </v-row>
        <v-row class="pb-0">
          <v-col cols="12" sm="6" lg="3">
            <v-text-field label="Bemiddelaar"
              v-model="detailMixin.element.schatting.bemiddelaar"/>
          </v-col>
          <v-col cols="12" sm="6" lg="3">
            <control-select
              :items="banken"
              label="Bank"
              v-model="detailMixin.element.schatting.idCodeBank"
              :itemValue="'idCode'"
              :itemText="'langeBeschrijving'" />
          </v-col>
        </v-row>
        <v-row class="pb-0">
          <v-col cols="12" sm="6" lg="3">
              <control-date
                v-model="detailMixin.element.schatting.datumPlaatsbezoek"
                label="Datum plaatsbezoek" />
          </v-col>
          <v-col cols="12" sm="6" lg="3">
              <control-date
                v-model="detailMixin.element.schatting.datumOpdracht"
                label="Datum opdracht" />
          </v-col>
          <v-col cols="12" sm="6" lg="3">
              <control-date
                v-model="detailMixin.element.schatting.datumOpmaakVerslag"
                label="Datum opmaken verslag" />
          </v-col>
        </v-row>

        <v-divider class="my-5"></v-divider>

        <h2 class="primary--text my-3">Algemene gegevens</h2>
        <h3 class="secondary--text my-3">Gegevens ontlener</h3>
        <v-row class="pb-0">
          <v-col cols="12" sm="6" lg="3">
              <v-text-field
                label="Voornaam"
                v-model="detailMixin.element.algemeneGegevens.voornaamOntlener" />
          </v-col>
          <v-col cols="12" sm="6" lg="3">
              <v-text-field
                label="Achternaam"
                v-model="detailMixin.element.algemeneGegevens.achternaamOntlener"/>
          </v-col>
          <v-col cols="12" sm="6" lg="3">
              <v-text-field
                label="Telefoon"
                :prepend-inner-icon="'mdi-phone'"
                v-model="detailMixin.element.algemeneGegevens.telefoonOntlener" />
          </v-col>
          <v-col cols="12" sm="6" lg="3">
              <v-text-field
                label="Email"
                v-model="detailMixin.element.algemeneGegevens.emailOntlener"
                :rules="[validationMixin.rules.email]"
                :prepend-inner-icon="'mdi-email'" />
          </v-col>
          </v-row>
          <v-row class="pb-0">
          <v-col cols="12" sm="6" md="4" lg="3">
              <v-text-field
                v-model="detailMixin.element.algemeneGegevens.straatOntlener"
                label="Straat" />
          </v-col>
          <v-col cols="12" sm="6" md="2" lg="3">
              <v-text-field
                v-model="detailMixin.element.algemeneGegevens.huisnummerOntlener"
                label="Huisnr." />
          </v-col>
          <v-col cols="12" sm="6" lg="3">
              <control-postcode
                v-on:change="SetPostcodeOntlener"
                v-model="detailMixin.element.algemeneGegevens.idPostcodeOntlener"
                label="Gemeente" />
          </v-col>
        </v-row>
        <h3 class="secondary--text my-3">Aard en ligging van het te schatten goed
          <span class="px-2 ma-0" style="color: grey; font-size: 12px">(*): Deze velden zijn verplicht!</span>
        </h3>
        <v-row class="pb-0">
          <v-col cols="12" sm="6" md="3">
            <option-list
              v-model="detailMixin.element.algemeneGegevens.aardGoed"
              :list="aarden"
              label="*Aard"
              :rules="[validationMixin.rules.required]"
            />
          </v-col>
          <v-col cols="12" sm="6" lg="3">
            <control-select
              :items="bebouwingen"
              label="Bebouwing"
              v-model="detailMixin.element.algemeneGegevens.idCodeBebouwing"
              :itemValue="'idCode'"
              :itemText="'langeBeschrijving'" />
          </v-col>
        </v-row>
        <v-row class="pb-0">
          <v-col cols="12" sm="6" md="4" lg="3">
              <v-text-field
                label="*Straat"
                v-model="detailMixin.element.algemeneGegevens.straat"
                :rules="[validationMixin.rules.required]" />
          </v-col>
          <v-col cols="12" sm="6" md="2" lg="3">
              <v-text-field
                label="*Huisnr."
                v-model="detailMixin.element.algemeneGegevens.huisnummer"
                :rules="[validationMixin.rules.required]" />
          </v-col>
          <v-col cols="12" sm="6" lg="3">
              <control-postcode
                label="*Gemeente"
                required
                v-model="detailMixin.element.algemeneGegevens.idPostcode"/>
          </v-col>
          </v-row>
        <h3 class="secondary--text my-3">
          Kadastrale aanduiding
        </h3>
          <v-row class="pb-0">
            <v-col cols="12" sm="6" lg="3">
                <v-text-field
                  label="Afdeling"
                  v-model="detailMixin.element.algemeneGegevens.kadastraleAfdeling" />
            </v-col>
            <v-col cols="12" sm="6" lg="3">
                <v-text-field
                  label="Sectie"
                  v-model="detailMixin.element.algemeneGegevens.kadastraleSectie" />
            </v-col>
            <v-col cols="12" sm="6" lg="3">
                <v-text-field
                  label="Nummers"
                  v-model="detailMixin.element.algemeneGegevens.kadastraleNummers"
                />
            </v-col>
          </v-row>
          <v-row class="pb-0">
            <v-col cols="12" sm="6" lg="3">
                <control-number
                  prefix="€"
                  label="Kadastraal inkomen (KI)"
                  v-model="detailMixin.element.algemeneGegevens.kadastraalInkomen" />
            </v-col>
        </v-row>

         <v-divider class="my-5"></v-divider>

        <h3 class="secondary--text my-3">Kaarten</h3>
        <geo-map
          :gemeente="GetSelectedPostcode()"
          :huisnummer="detailMixin.element.algemeneGegevens.huisnummer"
          :sliderZoom1="detailMixin.element.algemeneGegevens.zoomKaart1"
          :sliderZoom2="detailMixin.element.algemeneGegevens.zoomKaart2"
          :sliderZoom3="detailMixin.element.algemeneGegevens.zoomKaart3"
          :sliderZoom4="detailMixin.element.algemeneGegevens.zoomKaart4"
          :sliderZoom5="detailMixin.element.algemeneGegevens.zoomKaart5"
          :sliderZoom6="detailMixin.element.algemeneGegevens.zoomKaart6"
          :sliderZoom7="detailMixin.element.algemeneGegevens.zoomKaart7"
          :straat="detailMixin.element.algemeneGegevens.straat"
          :capakey="detailMixin.element.algemeneGegevens.capakey"
          @update:capakey="detailMixin.element.algemeneGegevens.capakey = $event"
          @zoom="ChangeZoomMaps($event)"
        />

         <v-divider class="my-5"></v-divider>

        <h3 class="secondary--text my-3">Bijlage</h3>
        <v-row class="pb-0">
          <v-col cols="12" md="6">
            <control-file-input-drag-and-drop v-model="detailMixin.element.files" @download="Download($event)" :accept="['.png', '.jpg', '.jpeg', '.gif']"/>
          </v-col>
        </v-row>
      </div>
    </v-form>
</template>

<script>
import errorMixin from '../../mixins/errorMixin'
import ControlFileInputDragAndDrop from '@/components/ControlFileInputDragAndDrop.vue'
import ControlPostcode from '@/components/ControlPostcode.vue'
import ControlSelect from '@/components/ControlSelect.vue'
import ControlDate from '@/components/ControlDate.vue'
import ControlNumber from '@/components/ControlNumber.vue'
import schattingService from '@/services/schattingService'
import geoService from '@/services/geoService'
import codeService from '@/services/codeService'
import postService from '@/services/postService'
import validationMixin from '@/mixins/validationMixin'
import commonMixin from '@/mixins/commonMixin'
import blobMixin from '@/mixins/blobMixin'
import detailMixin from '@/mixins/detailMixin'
import formatMixin from '@/mixins/formatMixin'
import GeoMap from '@/components/GeoMap.vue'
import authenticationMixin from '@/mixins/authenticationMixin'
import authenticationService from '../../services/authenticationService'
import OptionList from '@/components/OptionList.vue'
import offlineStorage from '@/utils/offlineStorage'
import networkStatus from '@/utils/networkStatus'
import { debounce } from 'lodash'

export default {
  mixins: [
    validationMixin,
    commonMixin,
    errorMixin,
    detailMixin,
    formatMixin,
    authenticationMixin,
    blobMixin
  ],
  components: {
    ControlDate,
    ControlSelect,
    ControlNumber,
    ControlFileInputDragAndDrop,
    ControlPostcode,
    GeoMap,
    OptionList
  },
  props: {
    idSchatting: {
      default: null,
      type: String
    },
    visible: Boolean
  },
  data () {
    return {
      aarden: [
        'Woning ',
        'Appartement',
        'Studio',
        'Opbrengsteigendom ',
        'Commercieel',
        'Kantoor',
        'KMO',
        'Industrieel',
        'Villa',
        'Bouwgrond ',
        'Landbouwgrond',
        'Natuurgebied',
        'Bosgrond',
        'Boerderij',
        'Projectgrond',
        'Garage'
      ],
      banken: [],
      bebouwingen: [],
      ext: '',
      gebruikers: [],
      opdrachtTemplates: [
        'Kredietaanvraag / Hypothecair krediet',
        'Aangifte nalatenschap conform Vlabel',
        'Schenking / Successie / Verdeling conform Vlabel',
        'Informatief',
        'Vereffening verdeling',
        'Inbreng in vennootschap',
        'Gerechtelijk procedure',
        'Openbare besturen'
      ],
      postcodes: null,
      referentieType: 'c1c7f6af-040d-4592-a5b9-b1cc0c9a7f37',
      selectedPostcode: null,
      showOfflineDialog: false
    }
  },
  async mounted () {
    this.SetVariables()
    geoService.Init(this)
    schattingService.Init(this)
    codeService.Init(this)
    postService.Init(this)
    this.initAutoSave()
    // Check network status and show dialog if offline
    if (!networkStatus.isOnline()) {
      this.showOfflineDialog = true
    } else {
      await this.LoadEverything()
      await this.GetSchattingStepsData()
      this.GetSchattingWithCache()
    }
  },
  watch: {
    idSchatting () {
      // Check network status before fetching
      if (!networkStatus.isOnline()) {
        this.showOfflineDialog = true
      } else {
        this.GetSchatting()
      }
    },
    mapScale () {
      if (this.mapimages !== null) {
        this.mapimage = this.mapimages.find(element => element.scale === this.mapScale).base64
        this.mapimage2 = this.mapimages2.find(element => element.scale === this.mapScale).base64
      }
    },
    visible () {
      if (!this.visible) {
        if (this.DetailMixin_Dirty) {
          this.DetailMixin_Save()
        }
      }

      if (this.visible && !this.DetailMixin_Revertable) {
        // Check network status before fetching
        if (!networkStatus.isOnline()) {
          this.showOfflineDialog = true
        } else {
          this.GetSchatting()
        }
      }
    },
    'detailMixin.element.schatting': {
      deep: true,
      handler: function (newVal, oldVal) {
        // Only auto-save if we have data and it's not the initial load
        if (newVal && oldVal && this.idSchatting) {
          this.debouncedAutoSave()
        }
      }
    },
    'detailMixin.element.algemeneGegevens': {
      deep: true,
      handler: function (newVal, oldVal) {
        // Only auto-save if we have data and it's not the initial load
        if (newVal && oldVal && this.idSchatting) {
          this.debouncedAutoSave()
        }
      }
    }
  },
  methods: {
    initAutoSave () {
      // Create a debounced version of the auto-save function
      // This will wait 1 second after the last change before saving
      this.debouncedAutoSave = debounce(this.autoSaveToCache, 1000)
    },
    async autoSaveToCache () {
      const id = this.DetailMixin_GetId()
      if (!id || !this.detailMixin.element?.schatting || !this.detailMixin.element?.algemeneGegevens) return

      try {
        await offlineStorage.schattingData.put({
          ...this.detailMixin.element.schatting,
          idSchatting: id,
          timestamp: Date.now(),
          syncStatus: 'cached'
        })
        await offlineStorage.saveSchattingStep('algemeneGegevens', id, this.detailMixin.element.algemeneGegevens)
        this.CommonMixin_Snackbar('Aanpassing lokaal opgeslagen', 'success')
      } catch (error) {
        console.error('Auto-save to cache failed:', error)
        this.CommonMixin_Snackbar('Automatisch opslaan mislukt', 'error')

        // Clear the error message after 3 seconds
        setTimeout(() => {
          if (this.autoSaveStatus === 'error') {
            this.autoSaveStatus = null
            this.autoSaveMessage = ''
          }
        }, 3000)
      }
    },
    ChangeZoomMaps (zoom) {
      for (let i = 1; i <= 4; i++) {
        this.detailMixin.element.algemeneGegevens[`zoomKaart${i}`] = zoom[`zoom${i}`]
      }
    },
    Download (blob) {
      const blobFormatted = this.CommonMixin_Clone(blob)
      blobFormatted.bestandsnaam = blob.name
      this.BlobMixin_Download(blobFormatted)
    },
    GetMap (type) {
      switch (type) {
        case 1:
          return `https://maps.geopunt.be/resources/apps/Minimaps_interface/index.html?lang=nl&adres=${this.detailMixin.element.algemeneGegevens.straat}%20${this.detailMixin.element.algemeneGegevens.huisnummer}%20${this.detailMixin.element.algemeneGegevens.gemeente}&lod=10&maximize=1&basemap=grb_grijs`
        case 2:
          return `https://maps.geopunt.be/resources/apps/Minimaps_interface/index.html?lang=nl&adres=${this.detailMixin.element.algemeneGegevens.straat}%20${this.detailMixin.element.algemeneGegevens.huisnummer}%20${this.detailMixin.element.algemeneGegevens.gemeente}&lod=10&maximize=1&basemap=grb`
        case 3:
          return `https://maps.geopunt.be/resources/apps/Gewestplan_app/index.html?lang=nl&adres=${this.detailMixin.element.algemeneGegevens.straat}%20${this.detailMixin.element.algemeneGegevens.huisnummer}%20${this.detailMixin.element.algemeneGegevens.gemeente}&lod=10&maximize=1&basemap=grb_grijs`
      }
    },
    async LoadEverything () {
      await Promise.all([
        this.GetBanken(),
        this.GetBebouwingen(),
        this.GetGebruikers(),
        this.GetPosten()
      ])
    },
    async GetSchatting () {
      // Check network status first
      if (!networkStatus.isOnline()) {
        await this.LoadDataFromCache()
        return
      }

      this.CommonMixin_Load(this.$options.name, true)

      const id = this.DetailMixin_GetId()

      if (id) {
        const responseSchatting = await schattingService.GetSchattingById(id)
        const responseAlgemeneGegevens = await schattingService.GetAlgemeneGegevensByIdSchatting(id)

        const element = {
          schatting: {},
          algemeneGegevens: {},
          files: []
        }

        // const files = await this.BlobMixin_GetFiles(this.idSchatting, this.referentieType)

        if (responseSchatting && (responseSchatting.data || responseSchatting.data !== '')) {
          element.schatting = this.CommonMixin_Clone(responseSchatting.data)

          await offlineStorage.schattingData.put({
            ...responseSchatting.data,
            idSchatting: id,
            timestamp: Date.now(),
            syncStatus: 'cached'
          })
        }

        if (responseAlgemeneGegevens && (responseAlgemeneGegevens.data || responseAlgemeneGegevens.data !== '')) {
          element.algemeneGegevens = this.CommonMixin_Clone(responseAlgemeneGegevens.data)

          await offlineStorage.saveSchattingStep('algemeneGegevens', id, responseAlgemeneGegevens.data)

          this.$forceUpdate()
        }

        this.detailMixin.element = this.CommonMixin_Clone(element)

        this.DetailMixin_InitDirtyWatch()
      }

      this.CommonMixin_Load(this.$options.name, false)
    },
    async GetSchattingWithCache () {
      this.CommonMixin_Load(this.$options.name, true)

      const id = this.DetailMixin_GetId()

      if (id) {
        const element = {
          schatting: {},
          algemeneGegevens: {},
          files: []
        }

        const cachedSchatting = await offlineStorage.schattingData.get(id)
        const cachedAlgemeneGegevens = await offlineStorage.getSchattingStep('algemeneGegevens', id)

        if (cachedSchatting && offlineStorage.isDataValid(cachedSchatting)) {
          element.schatting = cachedSchatting
          element.algemeneGegevens = cachedAlgemeneGegevens || {}
          this.detailMixin.element = this.CommonMixin_Clone(element)
          this.DetailMixin_InitDirtyWatch()
        }
        try {
          const [responseSchatting, responseAlgemeneGegevens] = await Promise.all([
            schattingService.GetSchattingById(id),
            schattingService.GetAlgemeneGegevensByIdSchatting(id)
          ])

          if (responseSchatting?.data) {
            element.schatting = responseSchatting.data
            await offlineStorage.schattingData.put({
              ...responseSchatting.data,
              idSchatting: id,
              timestamp: Date.now(),
              syncStatus: 'cached'
            })
          }

          if (responseAlgemeneGegevens?.data) {
            element.algemeneGegevens = responseAlgemeneGegevens.data
            await offlineStorage.saveSchattingStep('algemeneGegevens', id, responseAlgemeneGegevens.data)
          }

          if (networkStatus.isOnline()) {
            const files = await this.BlobMixin_GetFiles(this.idSchatting, this.referentieType)
            element.files = files
          }

          this.detailMixin.element = this.CommonMixin_Clone(element)
          this.$forceUpdate()
        } catch (error) {
          console.error('Fout bij het ophalen van schatting:', error)
        }

        this.DetailMixin_InitDirtyWatch()
      }
      this.CommonMixin_Load(this.$options.name, false)
    },
    ConvertFromStringToDateString (date) {
      const datePieces = date.split('/')
      return (`${datePieces[2]}-${datePieces[1]}-${datePieces[0]}`)
    },
    async GetBanken () {
      const cached = await offlineStorage.getLookupData('banken')
      if (cached) {
        this.banken = cached
      }

      try {
        const response = await codeService.GetBanken()
        if (response && response.data) {
          const data = response.data
          this.banken = data
          await offlineStorage.saveLookupData('banken', data)
        }
      } catch (error) {
        console.warn('Fout bij het ophalen van banken:', error)
      }
    },
    async GetBebouwingen () {
      const cached = await offlineStorage.getLookupData('bebouwingen')
      if (cached) {
        this.bebouwingen = cached
      }

      try {
        const response = await codeService.GetBebouwingen()
        if (response && response.data) {
          const data = response.data
          this.bebouwingen = data
          await offlineStorage.saveLookupData('bebouwingen', data)
        }
      } catch (error) {
        console.warn('Fout bij het ophalen van bebouwingen:', error)
      }
    },
    SetPostcodeOntlener: function (value) {
      this.idPostcodeOntlener = value
    },
    async GetGebruikers () {
      const cached = await offlineStorage.getLookupData('gebruikers')
      if (cached) {
        this.gebruikers = cached
      }

      try {
        const response = await authenticationService.GetGebruikersList()
        if (response && response.data) {
          const data = response.data
          this.gebruikers = data
        }
      } catch (error) {
        console.warn('Fout bij het ophalen van gebruikers:', error)
      }
    },
    SetVariables () {
      this.detailMixin.key = 'id'
      this.detailMixin.rightsNeeded = ['admin', 'gebruiker']
      this.detailMixin.functions.validate = this.$refs.formAlgemeen.validate
      this.detailMixin.functions.save = this.Save
    },
    async Save (element) {
      var schatting = await schattingService.UpdateSchatting(element.schatting)
      var schattingAlgemeneGegevens = await schattingService.UpdateSchattingAlgemeneGegevens(element.algemeneGegevens)
      await this.BlobMixin_SaveFiles(element.files, this.idSchatting, this.referentieType)
      var schattingData = null
      var schattingAlgemeneGegevensData = null
      if (schatting && schatting.data) {
        schattingData = schatting.data
      }
      if (schattingAlgemeneGegevens && schattingAlgemeneGegevens.data) {
        schattingAlgemeneGegevensData = schattingAlgemeneGegevens.data
      }
      return {
        data: {
          schatting: schattingData,
          algemeneGegevens: schattingAlgemeneGegevensData
        }
      }
    },
    GetSelectedPostcode () {
      if (this.postcodes !== null) {
        var selectedPostcode = this.postcodes.find(x => x.idPostcode === this.detailMixin.element.algemeneGegevens.idPostcode)
        if (selectedPostcode && selectedPostcode.tekst) {
          this.selectedPostcode = selectedPostcode.tekst
          return this.selectedPostcode
        }
      }
    },
    async GetPosten () {
      const cached = await offlineStorage.getLookupData('postcodes')
      if (cached) {
        this.postcodes = cached
      }

      try {
        const response = await postService.GetPosten()
        if (response && response.data) {
          const data = response.data
          this.postcodes = data
          await offlineStorage.saveLookupData('postcodes', data)
        }
      } catch (error) {
        console.warn('Fout bij het ophalen van postcodes:', error)
      }
    },
    async GetSchattingStepsData () {
      this.CommonMixin_Load(this.$options.name, true)

      const id = this.DetailMixin_GetId()

      // Set referenceID's for code selections
      const bijzonderElementRefId = '69c19641-94ad-4cc0-a670-328fe8d38e9b'
      const bouwmateriaalRefId = '0b197cc7-144e-4684-a1e3-6f2c07c21238'
      const nutsvoorzieningComfortRefId = 'c427744c-1ff2-41f8-8667-72c6daec33f2'
      const beschrijvingPandRefId = 'e7409aeb-0b8a-4d3b-adef-686b46c86160'

      // Filled in form data
      const responseAfmetingen = await schattingService.GetAfmetingenByIdSchatting(id)
      const responseBeschrijving = await schattingService.GetBeschrijvingPandByIdSchatting(id)
      const responseBijzondereElementen = await schattingService.GetBijzonderElementByIdSchatting(id)
      const responseBouwmaterialen = await schattingService.GetBouwmateriaalByIdSchatting(id)
      const responseNutsvoorzieningen = await schattingService.GetNutsvoorzieningComfortByIdSchatting(id)
      const responseWaarde = await schattingService.GetWaardeByIdSchatting(id)
      const responseVergelijkingspunten = await schattingService.GetVergelijkingspuntenByIdSchatting(id)

      if (responseAfmetingen && (responseAfmetingen.data || responseAfmetingen.data !== '')) {
        await offlineStorage.saveSchattingStep('afmetingen', id, responseAfmetingen.data)

        this.$forceUpdate()
      }

      if (responseBeschrijving && (responseBeschrijving.data || responseBeschrijving.data !== '')) {
        await offlineStorage.saveSchattingStep('beschrijvingPand', id, responseBeschrijving.data)

        this.$forceUpdate()
      }

      if (responseBijzondereElementen && (responseBijzondereElementen.data || responseBijzondereElementen.data !== '')) {
        await offlineStorage.saveSchattingStep('bijzonderElement', id, responseBijzondereElementen.data)

        this.$forceUpdate()
      }

      if (responseBouwmaterialen && (responseBouwmaterialen.data || responseBouwmaterialen.data !== '')) {
        await offlineStorage.saveSchattingStep('bouwmateriaal', id, responseBouwmaterialen.data)

        this.$forceUpdate()
      }

      if (responseNutsvoorzieningen && (responseNutsvoorzieningen.data || responseNutsvoorzieningen.data !== '')) {
        await offlineStorage.saveSchattingStep('nutsvoorzieningComfort', id, responseNutsvoorzieningen.data)

        this.$forceUpdate()
      }

      if (responseWaarde && (responseWaarde.data || responseWaarde.data !== '')) {
        await offlineStorage.saveSchattingStep('waarde', id, responseWaarde.data)

        this.$forceUpdate()
      }

      if (responseVergelijkingspunten && (responseVergelijkingspunten.data || responseVergelijkingspunten.data !== '')) {
        await offlineStorage.saveSchattingStep('vergelijkingspunten', id, responseVergelijkingspunten.data)

        this.$forceUpdate()
      }

      // Data to populate options and dropdowns in forms
      const responseBebouwingen = await codeService.GetBebouwingen()
      const responseBanken = await codeService.GetBanken()
      const responsePosten = await postService.GetPosten()
      const responseGebruikers = await authenticationService.GetGebruikersList()
      const responseKamerTypes = await codeService.GetKamerTypes()
      const responseBijgebouwTypes = await codeService.GetBijgebouwTypes()
      const responseSelectieControlTypes = await codeService.GetSelectieControlTypes()
      const responseAsbestInventarisList = await codeService.GetAsbestInventarisList()
      const responseElektriciteitsConformList = await codeService.GetElektriciteitConformList()
      const responseEpcLabelList = await codeService.GetEpcLabelList()
      const responseMetselwerkTypes = await codeService.GetMetselwerkTypes()
      const responseDakTypes = await codeService.GetDakTypes()
      const responseDakBedekkingTypes = await codeService.GetDakbedekkingTypes()
      const responseSchrijnwerkTypes = await codeService.GetSchrijnwerkTypes()
      const responseBeglazingTypes = await codeService.GetBeglazingTypes()
      const responseIsolatieTypes = await codeService.GetIsolatieTypes()
      const responseNutsvoorzieningTypes = await codeService.GetNutsvoorzieningTypes()
      const responseVerwarmingssysteem = await codeService.GetVerwarmingssysteemTypes()
      const responseComfortTypes = await codeService.GetComfortTypes()
      const responseAspectBetrokkenOmgevingTypes = await codeService.GetAspectBetrokkenOmgevingTypes()
      const responseStaatOnderhoudTuinTypes = await codeService.GetStaatOnderhoudTuinTypes()
      const responseStaatOnderhoudGebouwTypes = await codeService.GetStaatOnderhoudGebouwTypes()
      const respnoseVerkoopbaarheidTypes = await codeService.GetVerkoopbaarheidTypes()
      const responseErfdienstbaarheidTypes = await codeService.GetErfdienstbaarheidTypes()
      const responseGebruikPandTypes = await codeService.GetGebruikPandTypes()

      if (responseGebruikPandTypes && responseGebruikPandTypes.data) {
        const data = responseGebruikPandTypes.data
        await offlineStorage.saveLookupData('gebruikPandTypes', data)
      }

      if (responseErfdienstbaarheidTypes && responseErfdienstbaarheidTypes.data) {
        const data = responseErfdienstbaarheidTypes.data
        await offlineStorage.saveLookupData('erfdienstbaarheidTypes', data)
      }

      if (respnoseVerkoopbaarheidTypes && respnoseVerkoopbaarheidTypes.data) {
        const data = respnoseVerkoopbaarheidTypes.data
        await offlineStorage.saveLookupData('verkoopbaarheidTypes', data)
      }

      if (responseStaatOnderhoudGebouwTypes && responseStaatOnderhoudGebouwTypes.data) {
        const data = responseStaatOnderhoudGebouwTypes.data
        await offlineStorage.saveLookupData('staatOnderhoudGebouwTypes', data)
      }

      if (responseStaatOnderhoudTuinTypes && responseStaatOnderhoudTuinTypes.data) {
        const data = responseStaatOnderhoudTuinTypes.data
        await offlineStorage.saveLookupData('staatOnderhoudTuinTypes', data)
      }

      if (responseAspectBetrokkenOmgevingTypes && responseAspectBetrokkenOmgevingTypes.data) {
        const data = responseAspectBetrokkenOmgevingTypes.data
        await offlineStorage.saveLookupData('aspectBetrokkenOmgevingTypes', data)
      }

      if (responseComfortTypes && responseComfortTypes.data) {
        const data = responseComfortTypes.data
        await offlineStorage.saveLookupData('comfortTypes', data)
      }

      if (responseVerwarmingssysteem && responseVerwarmingssysteem.data) {
        const data = responseVerwarmingssysteem.data
        await offlineStorage.saveLookupData('verwarmingssysteem', data)
      }

      if (responseNutsvoorzieningTypes && responseNutsvoorzieningTypes.data) {
        const data = responseNutsvoorzieningTypes.data
        await offlineStorage.saveLookupData('nutsvoorzieningTypes', data)
      }

      if (responseIsolatieTypes && responseIsolatieTypes.data) {
        const data = responseIsolatieTypes.data
        await offlineStorage.saveLookupData('isolatieTypes', data)
      }

      if (responseBeglazingTypes && responseBeglazingTypes.data) {
        const data = responseBeglazingTypes.data
        await offlineStorage.saveLookupData('beglazingTypes', data)
      }

      if (responseSchrijnwerkTypes && responseSchrijnwerkTypes.data) {
        const data = responseSchrijnwerkTypes.data
        await offlineStorage.saveLookupData('schrijnwerkTypes', data)
      }

      if (responseDakBedekkingTypes && responseDakBedekkingTypes.data) {
        const data = responseDakBedekkingTypes.data
        await offlineStorage.saveLookupData('dakBedekkingTypes', data)
      }

      if (responseDakTypes && responseDakTypes.data) {
        const data = responseDakTypes.data
        await offlineStorage.saveLookupData('dakTypes', data)
      }

      if (responseMetselwerkTypes && responseMetselwerkTypes.data) {
        const data = responseMetselwerkTypes.data
        await offlineStorage.saveLookupData('metselwerkTypes', data)
      }

      if (responseEpcLabelList && responseEpcLabelList.data) {
        const data = responseEpcLabelList.data
        await offlineStorage.saveLookupData('epcLabels', data)
      }

      if (responseElektriciteitsConformList && responseElektriciteitsConformList.data) {
        const data = responseElektriciteitsConformList.data
        await offlineStorage.saveLookupData('elektriciteitsConform', data)
      }

      if (responseAsbestInventarisList && responseAsbestInventarisList.data) {
        const data = responseAsbestInventarisList.data
        await offlineStorage.saveLookupData('asbestInventaris', data)
      }

      if (responseBebouwingen && responseBebouwingen.data) {
        const data = responseBebouwingen.data
        await offlineStorage.saveLookupData('bebouwingen', data)
      }

      if (responseBanken && responseBanken.data) {
        const data = responseBanken.data
        await offlineStorage.saveLookupData('banken', data)
      }

      if (responsePosten && responsePosten.data) {
        const data = responsePosten.data
        await offlineStorage.saveLookupData('postcodes', data)
      }

      if (responseGebruikers && responseGebruikers.data) {
        const data = responseGebruikers.data
        await offlineStorage.saveLookupData('gebruikers', data)
      }

      if (responseKamerTypes && responseKamerTypes.data) {
        const data = responseKamerTypes.data
        await offlineStorage.saveLookupData('kamerTypes', data)
      }

      if (responseBijgebouwTypes && responseBijgebouwTypes.data) {
        const data = responseBijgebouwTypes.data
        await offlineStorage.saveLookupData('bijgebouwTypes', data)
      }

      if (responseSelectieControlTypes && responseSelectieControlTypes.data) {
        const data = responseSelectieControlTypes.data
        await offlineStorage.saveLookupData('selectieControlTypes', data)
      }

      const responseBeschrijvingPandMulticheck = await codeService.GetCodeSelectie(id, beschrijvingPandRefId)
      const responseBijzonderElementMulticheck = await codeService.GetCodeSelectie(id, bijzonderElementRefId)
      const responseBouwmateriaalMulticheck = await codeService.GetCodeSelectie(id, bouwmateriaalRefId)
      const responseNutsvoorzieningComfortMulticheck = await codeService.GetCodeSelectie(id, nutsvoorzieningComfortRefId)

      if (responseBeschrijvingPandMulticheck && responseBeschrijvingPandMulticheck.data) {
        const data = responseBeschrijvingPandMulticheck.data
        await offlineStorage.saveSchattingStep('beschrijvingPandCodeSelecties', id, data)
      }

      if (responseBijzonderElementMulticheck && responseBijzonderElementMulticheck.data) {
        const data = responseBijzonderElementMulticheck.data
        await offlineStorage.saveSchattingStep('bijzonderElementCodeSelecties', id, data)
      }

      if (responseBouwmateriaalMulticheck && responseBouwmateriaalMulticheck.data) {
        const data = responseBouwmateriaalMulticheck.data
        await offlineStorage.saveSchattingStep('bouwmateriaalCodeSelecties', id, data)
      }

      if (responseNutsvoorzieningComfortMulticheck && responseNutsvoorzieningComfortMulticheck.data) {
        const data = responseNutsvoorzieningComfortMulticheck.data
        await offlineStorage.saveSchattingStep('nutsvoorzieningComfortCodeSelecties', id, data)
      }
    },
    Validate () {
      this.$refs.formAlgemeen.validate()
      return this.detailMixin.valid
    },
    async handleOfflineContinue () {
      this.showOfflineDialog = false
      // Load data from cache when offline
      await this.LoadDataFromCache()
    },
    handleOfflineCancel () {
      this.showOfflineDialog = false
      // Navigate back or show message
      this.$router.go(-1)
    },
    async LoadDataFromCache () {
      this.CommonMixin_Load(this.$options.name, true)

      const id = this.DetailMixin_GetId()

      if (id) {
        const element = {
          schatting: {},
          algemeneGegevens: {},
          files: []
        }

        // Load all cached data
        const cachedSchatting = await offlineStorage.schattingData.get(id)
        const cachedAlgemeneGegevens = await offlineStorage.getSchattingStep('algemeneGegevens', id)

        if (cachedSchatting && offlineStorage.isDataValid(cachedSchatting)) {
          element.schatting = cachedSchatting
          element.algemeneGegevens = cachedAlgemeneGegevens || {}
          this.detailMixin.element = this.CommonMixin_Clone(element)
          this.DetailMixin_InitDirtyWatch()
        }

        // Load lookup data from cache
        this.banken = await offlineStorage.getLookupData('banken') || []
        this.bebouwingen = await offlineStorage.getLookupData('bebouwingen') || []
        this.gebruikers = await offlineStorage.getLookupData('gebruikers') || []
        this.postcodes = await offlineStorage.getLookupData('postcodes') || []
      }

      this.CommonMixin_Load(this.$options.name, false)
    }
  }
}
</script>
